import{styled as p}from"styled-components";const o=p.fieldset`
  padding: 2px 8px;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin: 4px;
  margin-top: 2px;
  box-shadow: 0px 2px 2px #eee;
`;export{o as BaseFieldSet};
